import { useEffect, useState } from "react";

// iOS/Android on-screen keyboards shrink the VISUAL viewport but not always the
// layout viewport — full-height chat panels then lose their composer behind the
// keyboard, or get left shifted/zoomed when the keyboard closes. Tracking the
// visual viewport lets a panel pin itself to exactly the visible area (header at
// the top, composer just above the keyboard) and restore cleanly on close.
export function useVisualViewport(enabled = true) {
  const [vv, setVv] = useState(null);
  useEffect(() => {
    if (!enabled || typeof window === "undefined" || !window.visualViewport) return undefined;
    const update = () => {
      const v = window.visualViewport;
      setVv({ height: v.height, top: v.offsetTop });
    };
    update();
    window.visualViewport.addEventListener("resize", update);
    window.visualViewport.addEventListener("scroll", update);
    return () => {
      window.visualViewport.removeEventListener("resize", update);
      window.visualViewport.removeEventListener("scroll", update);
    };
  }, [enabled]);
  return vv;
}

export function useIsMobile() {
  const [mobile, setMobile] = useState(() => typeof window !== "undefined" && window.innerWidth < 640);
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 639px)");
    const fn = () => setMobile(mq.matches);
    mq.addEventListener("change", fn);
    fn();
    return () => mq.removeEventListener("change", fn);
  }, []);
  return mobile;
}
